// WorkflowService (§18-§22). Řídí změny stavu tématu přes WorkflowEngine s
// kontrolou přechodů, oprávnění rolí a pravidel; zapisuje audit a publikuje události.
import { pushAudit } from "../core/audit.js";
import { nowISO } from "../core/model.js";

export class WorkflowService {
  constructor({ topicService, engine, repository, events, currentUser, currentRole }) {
    this.topicService = topicService;
    this.engine = engine;
    this.repository = repository;
    this.events = events;
    this.currentUser = currentUser || (() => null);
    this.currentRole = currentRole || (() => null);
  }
  _user() { const u = this.currentUser(); return (u && u.id) || u || null; }
  _role() { return this.currentRole(); }

  allowedTransitions(topicId) {
    const t = this.topicService.getTopic(topicId);
    return t ? this.engine.allowedTransitions(t) : [];
  }

  // Změna stavu (§26 changeStatus). Vyhodí chybu, pokud přechod není povolen.
  async changeStatus(topicId, toState, { role, userId } = {}) {
    const topic = this.topicService.getTopic(topicId);
    if (!topic) throw new Error("Téma nenalezeno: " + topicId);
    const ctx = { role: role || this._role(), userId: userId || this._user() };
    const check = this.engine.canTransition(topic, toState, ctx);
    if (!check.ok) { const e = new Error(check.error); e.code = "WORKFLOW_DENIED"; throw e; }

    const from = this.engine.currentState(topic);
    topic.workflow = { state: toState };
    topic.status = toState;
    topic.modifiedAt = nowISO();
    topic.modifiedBy = ctx.userId;
    pushAudit(topic, { userId: ctx.userId, action: toState === "closed" ? "Topic closed" : (from === "closed" ? "Topic reopened" : "Status changed"), before: from, after: toState });
    if (this.repository) await this.repository.saveTopic(topic);
    this.events && this.events.emit("bcf.workflow.changed", { topicId, from, to: toState });
    return topic;
  }

  async assign(topicId, user, { role, userId } = {}) {
    const topic = this.topicService.getTopic(topicId);
    if (!topic) throw new Error("Téma nenalezeno: " + topicId);
    const before = topic.assignedTo;
    topic.assignedTo = user;
    pushAudit(topic, { userId: userId || this._user(), action: "AssignedTo changed", before, after: user });
    if (this.repository) await this.repository.saveTopic(topic);
    this.events && this.events.emit("bcf.topic.updated", { topic });
    return topic;
  }
}
